import {
    HttpClient,
    HttpErrorResponse} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MessageService } from 'primeng';
import { throwError, Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import {
    DoctorFilterQuery,
    PatientFilterQuery,
    DoctorCsvDownload
} from '../models/AccountFilter';
import { payment_method } from '../models/basket';
import { PromiseResult } from '../models/PromiseResult';
import { RestApi } from '../shared/apiUrls';

@Injectable({
    providedIn: 'root'
})
export class AccountsService {
    constructor(
        private messageservice: MessageService,
        private readonly http: HttpClient
    ) {}

    private handleError(error: HttpErrorResponse) {
        return throwError(error);
    }

    GetPatientTransactions(
        body: PatientFilterQuery
    ): Observable<PromiseResult> {
        return this.http
            .post<PromiseResult>(
                RestApi.Urls.AccountsApi + 'Transaction/Get',
                body
            )
            .pipe(catchError(this.handleError));
    }

    GetDoctorTransactions(body: DoctorFilterQuery): Observable<PromiseResult> {
        return this.http
            .post<PromiseResult>(
                RestApi.Urls.AccountsApi + 'Transaction/Get/Doctors',
                body
            )
            .pipe(catchError(this.handleError));
    }

    downloadCsv(data: DoctorCsvDownload) {
        return this.http
          .post(
            RestApi.Urls.AccountsApi +
            'Transaction/Get/Doctors/export/csv',
            data, { observe: 'response', responseType: 'blob' })
          .pipe(catchError(this.handleError));
      }

    GetInvoice(transaction_id: string): Observable<PromiseResult> {
        return this.http
            .get<PromiseResult>(
                RestApi.Urls.AccountsApi +
                    'Transaction/Get/Invoice/' +
                    transaction_id
            )
            .pipe(catchError(this.handleError));
    }
    
    findPaymentDetails(payment_id:string, paymentgateway: payment_method) : Observable<PromiseResult> {
        return this.http
            .get<PromiseResult>(
                RestApi.Urls.AdminApis +
                    'payments/status/' +
                    paymentgateway + '/' + payment_id
            )
            .pipe(catchError(this.handleError));
    }
}
